module.exports = __webpack_public_path__ + "img/322.d8e8ce1c.png";